import { render, staticRenderFns } from "./DocumentEmail.vue?vue&type=template&id=faa95c90&scoped=true&"
import script from "./DocumentEmail.vue?vue&type=script&lang=js&"
export * from "./DocumentEmail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEmail.vue?vue&type=style&index=0&id=faa95c90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa95c90",
  null
  
)

export default component.exports